import { toast } from "../hooks/use-toast";

export function showSuccess(title, description) {
  toast({ title, description });
}

export function showError(title, description) {
  toast({ title, description, variant: "destructive" });
}

// SEO check returned by the backend after a save (title/description length,
// duplicates, homepage title). Shown after the "saved" toast so the content
// team fixes it before the page goes live.
export function showSeoWarnings(res) {
  const w = res?.data?.seo_warnings;
  if (!Array.isArray(w) || w.length === 0) return false;
  setTimeout(() => {
    toast({
      title: "Saved — please review SEO",
      description: w.join("  •  "),
      variant: "destructive",
    });
  }, 300);
  return true;
}
